import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import moment from 'moment-timezone';
import Moment = moment.Moment;

export class StripeRefund
{
    id: number;
    stripeRefundId: string;
    paymentAttemptId: number;
    transactionId: number;
    amount: number;
    // A fee-only refund returned the payer's prorated CC processing fee after a
    // principal refund (SD-7854). It reduced only the attempt's gross — never
    // net/applied — so it is excluded from original-amount reconstruction.
    feeOnly: boolean;
    // SD-10183: Stripe accepted the refund but it never reached the payer's bank.
    refundFailed: boolean;
    createdAt: Moment;

    constructor(refund: any) {
        this.id = refund.id || null;
        this.stripeRefundId = refund.stripeRefundId ?? refund.stripe_refund_id ?? null;
        this.paymentAttemptId = refund.paymentAttemptId ?? refund.payment_attempt_id ?? null;
        this.transactionId = refund.transactionId ?? refund.transaction_id ?? null;
        this.amount = refund.amount ?? null;
        this.feeOnly = !!(refund.feeOnly ?? refund.fee_only ?? false);
        this.refundFailed = !!(refund.refundFailed ?? refund.refund_failed ?? false);

        const timezone = LegFiJwtService.getTimezone();
        const createdAtRaw = refund.createdAt ?? refund.created_at;
        if (createdAtRaw) {
            this.createdAt = moment.utc(createdAtRaw, 'YYYY-MM-DD HH:mm:ss').tz(timezone);
        }
    }
}
